var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import { AppsWrapper, Wrapper, Title } from './styled';
import { Modules } from './Modules';
import { Container, Divider, IconContainer, } from '../../../../../../Layout/Header/components/Profile/styled';
import Dropdown from '../../../../../../../components/Dropdown';
import { AppstoreOutlined } from '../Icons';
import { useApps } from './hooks';
import { ymReachGoal } from '../../../../../../../helpers/common';
export var Apps = function (_a) {
    var accessToken = _a.accessToken;
    var _b = __read(useState(false), 2), isActive = _b[0], setIsActive = _b[1];
    var apps = useApps({ accessToken: accessToken }).apps;
    var handleClick = useCallback(function (e) {
        e.preventDefault();
        ymReachGoal('click_apps');
    }, []);
    if (!(apps === null || apps === void 0 ? void 0 : apps.length)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, null,
            React.createElement(Dropdown, { overlay: React.createElement(AppsWrapper, null,
                    React.createElement(Title, null, "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F"),
                    React.createElement(Modules, { apps: apps })), trigger: ['click'], placement: 'bottomRight', getPopupContainer: function (trigger) { return trigger.parentElement || document.body; }, onVisibleChange: setIsActive },
                React.createElement(Container, { onClick: handleClick },
                    React.createElement(IconContainer, null,
                        React.createElement(AppstoreOutlined, { "$isActive": isActive, "data-testid": 'apps-store-outlined-btn' }))))),
        React.createElement(Divider, null)));
};
//# sourceMappingURL=Apps.js.map